var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-switch',{attrs:{"color":"primary","value":_vm.pwaMode},on:{"click":function($event){return _vm.setPwaMode(!_vm.pwaMode)}}})}
var staticRenderFns = []

export { render, staticRenderFns }